import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { iStoreActions } from '../core/store-actions.interface';
import { FundingReviewModel } from '../../cmg-1003/models/funding-review.model';

function createInitialState(): FundingReviewModel {
  return <FundingReviewModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-funding-review-store' })
export class Cmg1003FundingReviewStore extends Store<FundingReviewModel> implements iStoreActions<FundingReviewModel> {
  constructor() {
    super(createInitialState());
  }

  preInitialize(fundingReview: FundingReviewModel): void {
    this.update(fundingReview);
  }
}
